import { render, staticRenderFns } from "./RelatedPartsIcon.vue?vue&type=template&id=07b65b6e&"
import script from "./RelatedPartsIcon.vue?vue&type=script&lang=js&"
export * from "./RelatedPartsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports